import { useRequest } from "./useRequest";
const Request = ({ setUseNoAuth, children }) => {
useRequest(setUseNoAuth);
  return <>{children}</>;
};

export default Request;
